import React from 'react'
import { Link } from "react-router-dom";


const HomeServices = () => {
    return (
        <>

            <section className="section-service" style={{ overflow: "hidden", marginTop:"-200px" }}>
                <div className="position-relative z-1">
                    <div className="section-bg-primary service-bg-map">
                        <div className="section-space">
                            <div className="container">
                                <div className="row justify-content-between gy-5">
                                    <div className="col-md-9 col-lg-6 col-xl-5" style={{marginTop:"-0px"}}>
                                        <div className="section-content-block">
                                            <span className="section-tag is-white">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="section-title is-text-dark">The services being offered by us includes</h2>
                                            {/* <p className="mt-3">
                                                From freight management to supply chain optimization, we are committed to
                                                providing the best services to ensure your success.
                                            </p> */}
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 col-xl-6">
                                        <ul className="service-style-2-list">
                                            <li className="service-style-2-item">
                                                <Link to="/road-transportation" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-5.svg" alt="service-style-2-icon-1" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Road Transportation</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </Link>
                                            </li>
                                            <li className="service-style-2-item">
                                                <a to="service-details.html" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-6.svg" alt="service-style-2-icon-2" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Rail Transportation</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="service-style-2-item">
                                                <a to="service-details.html" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-3.svg" alt="service-style-2-icon-3" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Air Transportation</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="service-style-2-item">
                                                <a to="service-details.html" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-2.svg" alt="service-style-2-icon-4" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Single Window Logistics Operations</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </a>
                                            </li>
                                            {/* <li className="service-style-2-item">
                                                <a to="service-details.html" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-5.svg" alt="service-style-2-icon-5" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Road Freight</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="service-style-2-item">
                                                <a to="service-details.html" className="service-style-2-link">
                                                    <div className="service-style-2-content">
                                                        <div className="service-style-2-icon">
                                                            <img src="assets/images/icons/service-style-2-icon-6.svg" alt="service-style-2-icon-6" width={41} height={41} className="img-fluid" />
                                                        </div>
                                                        <div className="service-style-2-text">Train Freight</div>
                                                    </div>
                                                    <div className="service-style-2-arrow">
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                        <span><i className="fa-sharp fa-regular fa-arrow-up-right" /></span>
                                                    </div>
                                                </a>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <img src="assets/images/service-track-img-1.png" alt="service-track-img-1" id="service-image" width={327} height={184} className="service-track-img" />
                </div>

            </section>


        </>
    )
}

export default HomeServices